export default {
  secondMenu: [], // 二级菜单
  thirdMenu: [], // 3级菜单
  common: {},
  eventData: {}
}
